/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Nav_LabelInputs */



/**
* | output |
* | --- |
* | "Quick tools navigation" |
*
* @param {Quicktools_Nav_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_nav_label = /** @type {((inputs?: Quicktools_Nav_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Nav_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Navigation QuickTools")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schnellnavigation")
	if (locale === "it") return /** @type {LocalizedString} */ ("Navigazione rapida degli strumenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Быстрая навигация по инструментам")
	if (locale === "es") return /** @type {LocalizedString} */ ("Navegación rápida por herramientas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快速工具导航")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クイックツールナビゲーション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("त्वरित उपकरण नेविगेशन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Navegação rápida de ferramentas")
	return /** @type {LocalizedString} */ ("Quick tools navigation")
});